export const TRACKING_LABELS = {
  serverSideDimension: {
    overview: 'ana-server-side-dimension-overview-set',
    bidder: 'ana-server-side-dimension-bidder-set',
    sites: 'ana-server-side-dimension-sites-set',
    adunit: 'ana-server-side-dimension-adunit-set',
    change: 'ana-server-side-dimension-change-apply',
  },
  timeline: {
    refresh: 'ana-server-side-timeline-refresh',
    download: 'ana-server-side-timeline-download',
  },
} as const
